import React from 'react';
import logoIcon from '../../assets/logo-icon.png';
import logoHorizontal from '../../assets/logo-horizontal.png';
import logoHorizontalWhite from '../../assets/logo-horizontal-white.png';

export const DutchDateIcon = ({ size = 48, className = '' }) => (
  <img
    src={logoIcon}
    alt="Dutch Date"
    width={size}
    height={size}
    className={className}
    style={{ width: size, height: size, objectFit: 'contain' }}
    data-testid="dutch-date-icon"
  />
);

export const DutchDateLogo = ({ className = '', height = 40, variant = 'dark' }: { className?: string; height?: number; variant?: 'dark' | 'white' }) => (
  <img
    src={variant === 'white' ? logoHorizontalWhite : logoHorizontal}
    alt="Dutch Date"
    className={className}
    style={{ height, width: 'auto', objectFit: 'contain' }}
    data-testid="dutch-date-logo"
  />
);

export default DutchDateIcon;
